<script>
import chartColors from '@/components/common/chart-colors';
import BaseChart from '@@/common/BaseChart';

const baseConfig = {
  tooltip: {
    useHTML: true,
    shadow: true,
    shared: true,
    borderWidth: 0,
    borderRadius: 12,
    backgroundColor: '#fff',
    headerFormat: '',
    pointFormatter() {
      return `
              <div>
                <b style="color:${this.color}">${this.category}:</b>
                <b>${this.y}%</b>
              </div>`;
    },
    followTouchMove: true,
    followPointer: true,
  },
  title: null,
  credits: { enabled: false },
  colors: chartColors,
  legend: false,
  plotOptions: {
    series: {
      colorByPoint: true,
      pointWidth: 16,
      borderRadiusTopLeft: 12,
      borderRadiusTopRight: 12,
    },
  },

  yAxis: {
    title: null,
    min: 0,
    softMax: 10,
    allowDecimals: true,
    tickAmount: 6,
    labels: {
      format: '{value}%',
    },
  },
};

export default {
  name: 'ColumnChart',
  components: {
    BaseChart,
  },
  props: {
    values: {
      type: Array,
      default: () => [],
    },
    xAxis: {
      type: Array,
      default: null,
    },
    height: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    config() {
      return {
        ...baseConfig,
        chart: {
          type: 'column',
          // width: '200px',
          height: this.height,
          spacingTop: 50,
        },
        xAxis: {
          categories: this.xAxis,
          labels: { autoRotation: false },
        },
        series: [{ data: this.values }],
      };
    },
  },
};
</script>

<template>
  <div class="column-chart">
    <BaseChart ref="chart" :options="config" />
  </div>
</template>

<style lang="scss">
.column-chart {
  flex-shrink: 0;
  // width: 200px;
  &__title {
    text-align: center;
    // width: 109px;
    // height: 109px;
    // border: 10px solid #f1f2f9;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
